import { useState, useEffect, useContext } from 'react';
import { Typography, Box, Stack } from '@mui/material';
import dayjs from 'dayjs'

const styles = {
    container: {
        display: 'flex',
        flexDirection: 'row',
    },
    row: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        height: 70,
        borderBottom: '1px solid black',
        width: '100%',
    },
    contentRow: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        height: 70,
        width: 100*48,
        position: 'relative',
        borderBottom: '1px solid black',
        position: 'relative'
    },
    day: {
        textAlign: 'center',
        flexDirection: "column",
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 50,
    },
    dateRound: {
        border: '1px solid black',
        borderRadius: 2,
        width: 30,
    },
    content: {
        width: '100%',
        overflow: 'hidden',
        overflowX: 'scroll',
    },
}

const calculatePosition = (day, start, end) => {

    //console.log(day, start, end)
    const dayStart = dayjs(day).startOf('day');
    const startMinutes = dayjs(start).diff(dayStart, 'minute');
    const endMinutes = dayjs(end).diff(dayStart, 'minute');

    //const startMinutes = dayjs(start).utcOffset(0, true).diff(dayjs(dayStart), 'minute');
    //const endMinutes = dayjs(end).utcOffset(0, true).diff(dayjs(dayStart), 'minute');

        
    return {
      left: `${(startMinutes / (24 * 60)) * 100}%`,
      width: `${((endMinutes - startMinutes) / (24 * 60)) * 100}%`,
    };
  };

const GanttContentRow = ({day, actions, width}) => {
    return (
        <Box sx={{...styles.contentRow, width: width}}>
            <Box sx={{position: 'absolute', zIndex:1, top: 0, left: 0}}><Typography sx={{fontSize: '12px'}}>{dayjs(day, 'YYYY-MM-DD').format('DD - ddd')}</Typography></Box>
            <Box sx={{display: 'flex', alignItems: 'center', width: '100%', height: 25, backgroundColor: 'green', zIndex:1, position: 'relative'}}>
                {actions.map(action=>{
                    const position = calculatePosition(day, action.from, action.to)
                    return(
                        <Box onDoubleClick={(e)=>{e.stopPropagation()}}key={action._id}  sx={{ display: 'flex', position:'absolute', alignItems: 'center', color: 'white', zIndex:2, height:25, backgroundColor: 'red', ...position }}>
                            <Stack sx={{ml:1, width:'100%'}} direction="row" alignItems="center" >
                            </Stack>
                            
                        </Box>
                    )
                })}
                
                {/*<Box sx={{ display: 'flex', alignItems: 'center', width: '100%', color: 'white', height:25, backgroundColor: isOccupied ? 'red' : 'green'}}>{isOccupied ? isOccupied.tenant.name : ""}</Box>*/}
            </Box>

        </Box>
    )
}

const GanttHeadContentRow = ({ intervals, width, minuteWidth }) => {
    console.log(width)
    let reductionFactor = 1;
    const showableIntervals = (() => {
        if (width < 500) {
            reductionFactor = 6;
        }
        else if (width < 800) {
            reductionFactor = 4;
            //return intervals.filter((interval, index) => index%reductionFactor === 0)
        }
        else if (width < 1000) {
            reductionFactor = 4;
            //return intervals.filter((interval, index) => index%reductionFactor === 0)
        }
        else if (width < 2000) {
            reductionFactor = 2;
            //return intervals.filter((interval, index) => index%reductionFactor === 0)
        }
        return intervals.filter((interval, index) => index%reductionFactor === 0)
    })()
    if (Array.isArray(intervals) && intervals.length >0) {
        return (
            <Box sx={{...styles.contentRow, width: width, justifyContent: 'flex-start'}}>
                {showableIntervals.map(interval => <Box key={`content-heading-${interval}`} sx={{display: 'flex', alignItems: 'center', width: `${minuteWidth*30*reductionFactor}px`, overflow: 'hidden' }}><Typography>{interval}</Typography></Box>)}
            </Box>
        )
    }
    return null;
}

const FitView = ({days, intervals, actions}) =>{
    const [viewportWidth, setViewportWidth] = useState(window.innerWidth);
    const totalMinutesInDay = 1440;
    const minuteWidth = viewportWidth / totalMinutesInDay;
    return (
        <Box sx={styles.container}>
            <Box sx={styles.content}>
                <GanttHeadContentRow intervals={intervals} width={viewportWidth} minuteWidth={minuteWidth}/> 
                {days.map(day =>(<GanttContentRow width={viewportWidth} key={`book-content-${day}`} day={day} intervals={intervals} actions={actions[day] || []}/>))}
            </Box>
        </Box> 
    ) 
}

export default FitView